import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App/index";
import { Auth0Provider } from "@auth0/auth0-react";
import { Router } from "react-router-dom";
import ProtectComponent from "./CommonComponents/Auth/ProtectComponent";
import SetupAxiosWithBearer from "./CommonComponents/Auth/SetUpAxiosWithBearer";
import history from "./history";
import "./i18n/config";

if (
  process.env.REACT_APP_ENVIRONMENT === "alus-development" ||
  process.env.REACT_APP_ENVIRONMENT === "local"
) {
  const { worker } = require("./mocks/browser");
  worker.start();
}

const onRedirectCallback = ({ returnTo = "/" }) => {
  history.replace(returnTo);
};

// TODO This need to be moved into a configuration file
// for speed keep it as is for now.

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      redirectUri={process.env.REACT_APP_AUTH0_REDIRECT_URI}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      scope={process.env.REACT_APP_AUTH0_SCOPE}
      onRedirectCallback={onRedirectCallback}
    >
      <ProtectComponent
        component={() => (
          <Router history={history}>
            <SetupAxiosWithBearer>
              <App />
            </SetupAxiosWithBearer>
          </Router>
        )}
      />
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
